import "jquery";
import * as ko from "knockout";
import { EconomyApi } from "../Apis/EconomyApi";
import { AccountStatementYear } from "../Models/Economy/AccountStatementYear";
import "footable-npm";
import { forEach } from "../../../node_modules/@types/lodash-es/index";
import { AccountStatement } from "../Models/Economy/AccountStatement";
import { SettingsApi } from "../Apis/SettingsApi";

export class AccountStatementsViewModel {
    private economyApi: EconomyApi;
    private fullAccountStatementYears: AccountStatementYear[];
    private $balanceSpan: JQuery;
    private $weOweYou: JQuery;
    private $youOweUs: JQuery;
    private $content: JQuery;
    private expirationDate: Date;
    accountStatementYears = ko.observableArray<AccountStatementYear>();
    invoiceSelected = ko.observable<boolean>(false);
    creditMemoSelected = ko.observable<boolean>(false);
    settlementSelected = ko.observable<boolean>(false);
    paymentSelected = ko.observable<boolean>(false);
    otherSelected = ko.observable<boolean>(false);
    loading = ko.observable<boolean>(false);
    balancePositive = ko.observable<boolean>(false);
    //showContent = ko.observable<boolean>(false);

    //Dateformat is dd-mm-yyyy
    isNew(dateString: string): boolean {
        let dateParts = dateString.split("-");
        const date = new Date(parseInt(dateParts[2], 10),
            parseInt(dateParts[1], 10) - 1,
            parseInt(dateParts[0], 10));
        return date > this.expirationDate;
    }

    constructor() {
        SettingsApi.getInstance().getExpirationDate().then((res) => this.expirationDate = res);
        this.economyApi = EconomyApi.getInstance();
        this.$balanceSpan = $("#balanceSpan");
        this.$weOweYou = $("#weOweYou");
        this.$youOweUs = $("#youOweUs");
        this.$content = $(".statement-content");
    }

    init(): void {
        this.$content.hide();
        this.$weOweYou.hide();
        this.$youOweUs.hide();
        this.loading(true);
        this.economyApi.getAccountStatements().then((res) => {
            this.fullAccountStatementYears = res;
            this.updateTable();
        });
    }

    updateTable(): void {
        this.loading(true);
        this.$content.addClass("d-none");
        this.$content.css("display", "none");
        let acceptedAccountStatementYears = new Array<AccountStatementYear>();

        this.fullAccountStatementYears.forEach(accountStatementYear => {
            let acceptedAccountStatements = new Array<AccountStatement>();

            accountStatementYear.AccountStatements.forEach(accountStatement => {
                try {
                    if (this.$balanceSpan.text() == "") {
                        let balance = accountStatement.Balance;

                        this.$balanceSpan.text(Math.abs(balance)
                            .toLocaleString('da-DK', { maximumFractionDigits: 2, minimumFractionDigits: 2 }));

                        if (balance >= 0) {
                            this.$youOweUs.show();
                            this.$weOweYou.hide();
                            this.balancePositive(false);
                        } else if (balance <= 0) {
                            this.$youOweUs.hide();
                            this.$weOweYou.show();
                            this.balancePositive(true);
                        }
                        console.log(this.balancePositive());

                    }
                } catch (e) {
                    console.log(e);
                }

                if (this.IsAccepted(accountStatement)) {
                    acceptedAccountStatements.push(accountStatement);
                }
            });

            if (acceptedAccountStatements.length != 0) {
                acceptedAccountStatementYears.push(
                    new AccountStatementYear(accountStatementYear.Year, acceptedAccountStatements));
            }
        });

        if (acceptedAccountStatementYears.length < 1) {
            acceptedAccountStatementYears = this.fullAccountStatementYears;

        }
        this.accountStatementYears(acceptedAccountStatementYears);


        ($('.accountStatementFooTable') as any).footable();

        this.delay(150).then(() => {
            this.loading(false);
            //this.showContent(true);
            this.$content.removeClass("d-none");
            this.$content.css("display", "inline");
        });
    }

    deselectInvoice(): void {
        this.invoiceSelected(false);
        this.updateTable();
    }

    deselectCreditMemo(): void {
        this.creditMemoSelected(false);
        this.updateTable();
    }

    deselectSettlement(): void {
        this.settlementSelected(false);
        this.updateTable();
    }

    deselectOther(): void {
        this.otherSelected(false);
        this.updateTable();
    }

    deselectAll(): void {
        this.invoiceSelected(false);
        this.creditMemoSelected(false);
        this.settlementSelected(false);
        this.paymentSelected(false);
        this.otherSelected(false);

        this.updateTable();
    }

    private hasActiveFilter: KnockoutComputed<boolean> = ko.computed(() => {

        return this.invoiceSelected() ||
            this.creditMemoSelected() ||
            this.settlementSelected() ||
            this.paymentSelected() ||
            this.otherSelected();
    });

    private IsAccepted(accountStatement: AccountStatement): boolean {
        if (accountStatement.TypeCodeId == "2" && this.invoiceSelected()) {
            return true;
        } else if (accountStatement.TypeCodeId == "7" && this.settlementSelected()) {
            return true;
        } else if (accountStatement.TypeCodeId == "3" && this.creditMemoSelected()) {
            return true;
        } else if (accountStatement.TypeCodeId == "0" && this.otherSelected()) {
            return true;
        } else if (accountStatement.TypeCodeId == "1" && this.paymentSelected()) {
            return true;
        } else {
            return false;
        }
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}